import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_getWeatherLocation, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getWeatherLocation';

export type WeatherModelType = Response200Type;

const decode = (status: number, data: ResponseType): WeatherModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface ParamsDataType {
    race_slug: string,
}

export const getActiveWeatherLocation = {
    browser: {
        params: (params: ParamsDataType): ParamsFetchType<ParamsDataType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get_weather_data',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get_weather_data',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<ParamsDataType>): Promise<GenerateUrlApiType> => {
        const response = await openapi_website_cms_getWeatherLocation(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
